module.exports = __webpack_public_path__ + "fonts/SHUJIANTI-2_0.c50dab7e.TTF";